export { default } from "./InputLabel.mjs";
export { default as inputLabelClasses } from "./inputLabelClasses.mjs";
export * from "./inputLabelClasses.mjs";